// Safari before 18 exposes only the prefixed computed property.
export function getComputedBackdropBlur(element: Element): number {
  const style = getComputedStyle(element);
  const value =
    style.getPropertyValue('backdrop-filter').match(/blur\(([^)]+)/)?.[1] ??
    style
      .getPropertyValue('-webkit-backdrop-filter')
      .match(/blur\(([^)]+)/)?.[1];
  return parseFloat(value || '0') || 0;
}
